module.exports = __webpack_public_path__ + "media/images/icons/icn_023-652f07289029bb1b2acf4709f9096bea.svg";